import styled from 'styled-components';

export const UpcomingAppointmentCardStyle = styled.div<{ fullWidth: boolean }>`
  width: ${(props) => (props.fullWidth ? 'auto' : '360px')};
  min-width: ${(props) => (props.fullWidth ? 'auto' : '360px')};
  height: 100px;
  text-align: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.background.default};
  box-shadow: ${({ theme }) => theme.shadows[24]};
  transition: box-shadow 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin: ${(props) => (props.fullWidth ? '4px 0' : '4px')};
  background-color: ${({ theme }) => theme.palette.background.paper};
  align-items: center;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[24]};
  }

  h2 {
    margin: 0;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 97%;
  }
`;

export const DateSection = styled.div<{ colour: string }>`
  height: 84px;
  width: 22%;
  border-right: 2px solid ${(props) => props.colour};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Month = styled.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Day = styled.div`
  font-size: 32px;
  font-weight: 200;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Information = styled.div`
  height: 65%;
  width: 60%;
  padding-left: 5%;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: space-between;
`;

export const Time = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
  line-height: 19px;
`;

export const Name = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.secondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
`;

export const Location = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 19px;
`;
